(function ($) {
    $('.woocommerce-form').on('submit', function () {
        $(this).find('[type="submit"]').addClass('working');
    });
})( jQuery )